/*
 * 用户管理查询用户列表 *
 * *
 * */

import {
    GetUserListReq
} from "@/pbjs/external/user/user_pb";
import { userClient } from "@/api/userClient";
import {Page, timeFormat} from "@/utils/index";
import {setCommon, setPage} from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
    inputName?: string;
    inputEmail?: string;
    roleValue?: string;
    userStatus?: number;
    userId?: number;
    searchStaffId?: string;
    twoFactAuthRange?: number;
    outSourceRange?: number;
    attendancetimefrom?: string;
    attendancetimeto?: string;
    Page: Page;
}
export function setGetUserListReq(arg: Options) {
    let request: any = new GetUserListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setName(arg.inputName);
    request.setEmail(arg.inputEmail);
    request.setUsergroup(arg.roleValue);
    request.setUserstatusrange(arg.userStatus);
    request.setAttendancetimefrom(arg.attendancetimefrom);
    request.setAttendancetimeto(arg.attendancetimeto);
    request.setTwofactauthrange(arg.twoFactAuthRange);
    request.setOutsourcerange(arg.outSourceRange);
    request.setUserid(arg.userId);
    request.setEmployeeid(arg.searchStaffId);
    return request;
}
export const getUserListRequest = new InnerRequest(
    userClient,
    userClient.getUserList
);
export const exportExcelRequest = new InnerRequest(
    userClient,
    userClient.downloadUserExcel
);